// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14yqc","col":"styles_col__1NAf1"};